import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces/api/notifications";
import { patchDismissNotification } from "../../../services/notifications/patchDismissNotification";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation, WSMutationConfig, WSQueryCache } from "../../helpers";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../keys";

export const useDismissNotification = (
  config?: WSMutationConfig<
    IChannelNotificationResponse,
    WSServiceError,
    string
  >
) =>
  useWSMutation((id: string) => {
    // Optimistic update
    WSQueryCache.setQueryData(QUERY_NOTIFICATIONS_NOTIFICATIONS, () => {
      return WSQueryCache.getQueryData<IChannelNotificationResponse[]>(
        QUERY_NOTIFICATIONS_NOTIFICATIONS
      )?.filter(notificaiton => notificaiton.channelMessageId !== id);
    });

    return patchDismissNotification(id);
  }, config);
